module.exports = __webpack_public_path__ + "static/media/all-sunny.15e0ab24.mp3";